import React from 'react';

function SkillUpdateModal({ isOpen, skillData, onClose }) {
  if (!isOpen || !skillData) return null;

  const { skillId, oldRating, newRating, change, coachName } = skillData;

  // Get skill name from ID (common padel skills)
  const getSkillName = (id) => {
    const skillNames = {
      'forehand': 'Forehand',
      'backhand': 'Backhand',
      'serve': 'Serve',
      'volley': 'Volley',
      'overhead': 'Overhead',
      'footwork': 'Footwork',
      'court_awareness': 'Court Awareness',
      'mental_strength': 'Mental Strength',
      'consistency': 'Consistency',
      'power': 'Power',
      'control': 'Control',
      'positioning': 'Positioning',
    };
    return skillNames[id] || id.charAt(0).toUpperCase() + id.slice(1).replace(/_/g, ' ');
  };

  const changeSymbol = change > 0 ? '📈' : '📉';
  const changeColor = change > 0 ? '#27ae60' : '#e74c3c';

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      animation: 'fadeIn 0.3s ease-out'
    }}>
      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: scale(0.9);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        @keyframes slideInUp {
          from {
            transform: translateY(20px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
      `}</style>

      <div style={{
        background: 'white',
        borderRadius: '16px',
        padding: '32px',
        maxWidth: '400px',
        width: '90%',
        boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)',
        textAlign: 'center',
        animation: 'slideInUp 0.4s ease-out'
      }}>
        {/* Header */}
        <div style={{ marginBottom: '24px' }}>
          <h2 style={{
            fontSize: '28px',
            margin: '0 0 8px 0',
            color: '#2c3e50'
          }}>
            🎯 Skill Update
          </h2>
          <p style={{
            margin: 0,
            fontSize: '14px',
            color: '#7f8c8d'
          }}>
            {coachName} just rated your progress
          </p>
        </div>

        {/* Skill Info */}
        <div style={{
          background: '#f8f9fa',
          borderRadius: '12px',
          padding: '20px',
          marginBottom: '24px'
        }}>
          <p style={{
            margin: '0 0 12px 0',
            fontSize: '16px',
            fontWeight: '600',
            color: '#2c3e50'
          }}>
            {getSkillName(skillId)}
          </p>

          {/* Rating Display */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '16px',
            marginBottom: '16px'
          }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}>
              <span style={{
                fontSize: '12px',
                color: '#7f8c8d',
                marginBottom: '4px'
              }}>
                Before
              </span>
              <span style={{
                fontSize: '24px',
                fontWeight: '700',
                color: '#95a5a6'
              }}>
                {oldRating}
              </span>
            </div>

            <span style={{
              fontSize: '28px',
              color: changeColor
            }}>
              →
            </span>

            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}>
              <span style={{
                fontSize: '12px',
                color: '#7f8c8d',
                marginBottom: '4px'
              }}>
                After
              </span>
              <span style={{
                fontSize: '24px',
                fontWeight: '700',
                color: changeColor
              }}>
                {newRating}
              </span>
            </div>
          </div>

          {/* Change Badge */}
          <div style={{
            background: changeColor,
            color: 'white',
            padding: '8px 16px',
            borderRadius: '8px',
            display: 'inline-block',
            fontSize: '14px',
            fontWeight: '600'
          }}>
            {changeSymbol} {change > 0 ? '+' : ''}{change} point{Math.abs(change) !== 1 ? 's' : ''}
          </div>
        </div>

        {/* Motivation Message */}
        <div style={{
          background: '#e8f5e9',
          color: '#27ae60',
          padding: '12px',
          borderRadius: '8px',
          fontSize: '13px',
          marginBottom: '20px',
          fontWeight: '500'
        }}>
          {change > 0
            ? '🌟 Keep up the great work!'
            : change < 0
            ? '💪 Keep practicing, you\'ll get there!'
            : '✨ Your effort is being recognized!'}
        </div>

        {/* Close Button */}
        <button
          onClick={onClose}
          style={{
            width: '100%',
            padding: '12px 20px',
            background: 'linear-gradient(135deg, #3498db 0%, #2980b9 100%)',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontSize: '14px',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'all 0.2s'
          }}
          onMouseOver={(e) => {
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 4px 12px rgba(52, 152, 219, 0.4)';
          }}
          onMouseOut={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = 'none';
          }}
        >
          Got it! 🎾
        </button>
      </div>
    </div>
  );
}

export default SkillUpdateModal;
